import React from 'react';
import ReactTooltip from 'react-tooltip';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Reducers } from 'store/types';
import { UserProfile } from 'api/account/models/UserProfile';
import { FaCommentDots } from 'react-icons/fa';
import styles from './SmsWarningIcon.module.scss';

const SmsWarningIcon: React.FC = () => {
    const { t } = useTranslation();
    const profile = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);

    const totalSmsPurchased = profile?.totalSmsPurchased ?? 0;
    if (totalSmsPurchased <= 0) {
        return null;
    }

    const smsRemaining = profile?.smsRemaining ?? 0;

    if (smsRemaining > 10) {
        return null;
    }

    const isDanger = smsRemaining <= 0;

    const tooltipMessage = isDanger
        ? t('sms.tooltip_depleted')
        : t('sms.tooltip_warning', { remaining: smsRemaining });

    const iconColor = isDanger ? '#DC4C4C' : '#E2B434';

    return (
        <>
            <FaCommentDots
                className={styles.icon}
                color={iconColor}
                data-tip={tooltipMessage}
            />
            <ReactTooltip />
        </>
    );
};

export default SmsWarningIcon;
